import React,{useContext,useState,useEffect} from 'react';
import AuthContext from './Contexts/AuthContext';
import Modal from 'react-modal'
import countries from './utils/countries.json'
import Address from './Address';
import settings from '../../settings.json'
import axios from 'axios'
import TitoloPagine from './TitoloPagine';
import {SpinnerInsidePage } from '../MainComponents/Spinner';

let adBlank = {name:null, lastname:null,city:null,zipcode:null,address:null,state:null,id:null}
function UserProfile(props) {
    const contextAuth = useContext(AuthContext)
    const [profile, setProfile] = useState(undefined)
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [address, setAddress] = useState(null)
    const [addressBlank, setaddressBlank] = useState(adBlank)
    const header = { 'headers': { 'Authorization': 'Token '+contextAuth.AuthState.token }}

    useEffect(() => {
        setProfile(contextAuth.AuthState.user)
    }, contextAuth.AuthState.user)

    function setProfileInput(e){
        setAddress({...address, [e.target.name]:e.target.value})
    }
    function setBankProfileInput(e){
        setaddressBlank({...addressBlank, [e.target.name]:e.target.value})
    }

    function openModal(ad,open){
        if(!open){
            setAddress(null)
        }else{
            setAddress(ad)
        }
        setIsOpenModal(open)
    }
    function aggiornaAddress(e){
        e.preventDefault()
        axios.put(settings.url_api+"/api/address/"+address.id+"/",address,header).then(res=>{
            const elementsIndex = profile.address_list.findIndex(element => element.id == address.id )
            let newArray = [...profile.address_list]
            newArray[elementsIndex] = address
            console.log(newArray)
            setProfile({...profile, address_list:newArray})
            openModal(null,false)
        })
    }

    function nuovoAddress(e){
        e.preventDefault()
        axios.post(settings.url_api+"/api/address/",addressBlank,header).then(res=>{
            let listofaddress=profile.address_list
            listofaddress.push(res.data)
            setProfile({...profile, address_list:listofaddress})
            openModal(null,false)
        })
    }

    function deleteAddress(address){
        axios.delete(settings.url_api +"/api/address/"+address.id+"/",header).then((res)=>{
            let address_list = contextAuth.AuthState.user.address_list.filter(addr => addr.id !== address.id);
            setProfile({...profile, address_list:address_list})
        })
    }

    return (
        <div>
            {profile ?
            <div style={{textAlign:"left"}}>
                <div>
                    <TitoloPagine title={"I MIEI DATI"}></TitoloPagine>
                    <div className="row profile-userinfo" style={{marginTop:"15px"}}>
                        {/* {JSON.stringify(profile)} */}
                        <div className="col-12">
                            {profile.first_name + " " + profile.last_name}
                        </div>
                        <div className="col-12">
                            <b>{profile.email}</b> {profile.phone ? <span> - <b>Tel.</b> {profile.phone}</span> : null}
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{marginTop:"20px"}}>
                        <TitoloPagine title={"I MIEI INDIRIZZI"}></TitoloPagine>
                        <div> 
                            <button className="button-resume" onClick={(e)=>{openModal(null,true)}}> <i className="fa fa-plus"></i> Crea Nuovo indirizzo</button>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:"15px"}}>
                    {profile.address_list.map((address,i)=>{
                        return(
                            <Address key={i} address={address} showButton={true} openModal={openModal} deleteAddress={deleteAddress}></Address>
                        )
                    })}
                    </div>
                </div>
                <Modal isOpen={isOpenModal} className="modal-content" ariaHideApp={false}>
                    {address ? 
                        <div className="container">
                            <h4>Aggiungi indirizzo</h4>
                            <form onSubmit={(e)=>{aggiornaAddress(e)}}>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Nome</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="name" value={address.name} onChange={(e)=>{setProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Cognome</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="lastname" value={address.lastname} onChange={(e)=>{setProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Città</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="city" value={address.city} onChange={(e)=>{setProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Via</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"> <input required name="address" value={address.address}  onChange={(e)=>{setProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Stato</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"> 
                                        <select required name="state" id="state" value={address.state}  onChange={(e)=>{setProfileInput(e)}}>
                                            <option value=""></option>
                                            {countries.map((country,i)=>{
                                                return(
                                                <option key={i} value={country.code}>{country.name}</option>
                                                )
                                            })}
                                        </select>        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>CAP</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="zipcode" value={address.zipcode}  onChange={(e)=>{setProfileInput(e)}} /></div>
                                </div>                                
                                <button>Aggiorna</button>
                                </form>  
                            <button onClick={(e)=>{openModal(null,false)}}>Close Modal</button>
                        </div>
                    : 
                    <div className="container">
                            <h4>Aggiungi indirizzo</h4>
                            <form onSubmit={(e)=>{nuovoAddress(e)}}>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Nome</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="name" value={addressBlank.name} onChange={(e)=>{setBankProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Cognome</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="lastname" value={addressBlank.lastname} onChange={(e)=>{setBankProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Città</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="city" value={addressBlank.city} onChange={(e)=>{setBankProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Via</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"> <input required name="address" value={addressBlank.address}  onChange={(e)=>{setBankProfileInput(e)}}/></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>Stato</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"> 
                                        <select required name="state" id="state" value={addressBlank.state}  onChange={(e)=>{setBankProfileInput(e)}}>
                                            <option value=""></option>
                                            {countries.map((country,i)=>{
                                                return(
                                                <option key={i} value={country.code}>{country.name}</option>
                                                )
                                            })}
                                        </select>        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"><b>CAP</b></div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12"><input required name="zipcode" value={addressBlank.zipcode}  onChange={(e)=>{setBankProfileInput(e)}} /></div>
                                </div>                                
                                <button>Salva</button>
                                </form>  
                            <button onClick={(e)=>{openModal(null,false)}}>Close Modal</button>
                        </div> }
                    </Modal>
                </div>
             : <div>
                <SpinnerInsidePage/>
                </div>}
        </div>
    );
}

export default UserProfile;